import React from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loading-overlay';
import {I18nUtils} from "../../../i18n/I18nUtils";

export default class Tab extends React.Component {

  render() {
    const colWidth = this.props.colWidth ? this.props.colWidth : 'col-lg-12 col-md-12 col-sm-12 col-xs-12';

    return (
      <div className={colWidth}>
        <Loadable
          active={this.props.loading}
          spinner
          text={I18nUtils.tr('TR_CARGANDO')}
          background={'rgba(255,255,255,.9)'}
          color={'rgb(0,0,0)'}
          zIndex={10}
        >
        {this.props.children}
        </Loadable>
      </div>
    );
  }

}

Tab.propTypes = {
  colWidth: PropTypes.string,
  loading: PropTypes.bool
};

Tab.defaultProps = {
  loading: false
};



// WEBPACK FOOTER //
// ./src/app/shared/components/Tab.js